import type { ReactNode } from 'react';
import classnames from 'classnames';
import * as styles from './Alert.module.scss';

interface IAlertProps {
    alertHeading?: string;
    children: ReactNode;
    className?: string;
    variant: 'danger' | 'info' | 'success' | 'warning';
}
export function Alert(props: IAlertProps) {
    return (
        <div
            className={classnames(`${styles.alert} `, styles[props.variant], props.className || '')}
            role="alert"
        >
            {props.alertHeading && (
                <h4 className={classnames(`${styles.alertHeading} `, styles[props.variant])}>{props.alertHeading}</h4>
            )}
            {props.children}
        </div>
    );
}
